(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["free-gift"] && !Shopify.designMode) return;
  try {
    class FreeGiftComponent {
    constructor(element) {
      this.element = element;
      this.mainProductId = element.dataset.mainProductId;
      this.giftProductIds = element.dataset.giftProducts.split(',').filter(id => id.trim());
      this.isProcessing = false;
      this.debounceTimer = null;
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        requestAnimationFrame(() => this.init());
      }
    }

    init() {
      this.boundHandleSubmit = this.handleFormSubmit.bind(this);
      this.boundHandleCartUpdate = this.handleCartUpdate.bind(this);
      
      document.addEventListener('submit', this.boundHandleSubmit, true);
      document.addEventListener('cart:update', this.boundHandleCartUpdate);
      
      this.observeForms();
    }

    observeForms() {
      const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
      forms.forEach(form => {
        if (!form.dataset.freeGiftObserved) {
          form.dataset.freeGiftObserved = 'true';
          form.addEventListener('submit', this.boundHandleSubmit, true);
        }
      });
    }

    async handleFormSubmit(event) {
      const form = event.target;
      
      if (form.dataset.type === 'add-to-cart-form' && this.giftProductIds.length > 0 && !this.isProcessing) {
        event.preventDefault();
        event.stopImmediatePropagation();
        
        this.isProcessing = true;
        
        requestAnimationFrame(async () => {
          try {
            await this.processFormSubmission(form);
          } catch (error) {
            console.error('Error in form submission:', error);
            this.showErrorMessage();
          } finally {
            this.isProcessing = false;
          }
        });
      }
    }

    async processFormSubmission(form) {
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || 1);
      
      if (!variantId) {
        throw new Error('No variant ID found');
      }
      
      const mainProduct = {
        id: variantId,
        quantity: quantity,
        properties: this.getFormProperties(formData)
      };
      
      const giftProducts = this.giftProductIds
        .filter(id => id.trim())
        .map(giftVariantId => ({
          id: giftVariantId.trim(),
          quantity: 1,
          properties: {
            '_free_gift': 'true',
            '_linked_to_variant': variantId,
            '_gift_block_id': this.element.dataset.mainProductId || 'any'
          }
        }));
      
      const allProducts = [mainProduct, ...giftProducts];
      
      const cartResponse = await this.addProductsToCartOptimized(allProducts);
      
      await this.updateCartUIOptimized(cartResponse);
    }

    getFormProperties(formData) {
      const properties = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[') && key.endsWith(']')) {
          const propertyName = key.slice(11, -1);
          properties[propertyName] = value;
        }
      }
      return properties;
    }

             async addProductsToCartOptimized(products) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: products
          })
        });

        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.message || data.description || 'Failed to add products to cart');
        }

        return data;
      } catch (error) {
        console.warn('Batch add failed, trying individual adds:', error);
        return this.addProductsIndividually(products);
      }
    }

    async addProductsIndividually(products) {
      const results = [];
      for (const product of products) {
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(product)
          });
          
          const data = await response.json();
          if (response.ok) {
            results.push(data);
          }
        } catch (error) {
          console.error('Failed to add individual product:', product, error);
        }
      }
      return results;
    }

         async handleCartUpdate(event) {
      if (event.detail.data && event.detail.data.source === 'free-gift') {
        return;
      }
      
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      
      this.debounceTimer = setTimeout(async () => {
        try {
          const cartState = await this.fetchCartState();
          await this.removeOrphanedGifts(cartState);
        } catch (error) {
          console.error('Error handling cart update:', error);
        }
      }, 150);
    }

    async updateCartUIOptimized(cartResponse) {
      try {
        let cartState = cartResponse;
        
        if (!cartState || !cartState.items) {
          cartState = await this.fetchCartState();
        }
        
        this.triggerCartEvents(cartState, 'free-gift');
        
      } catch (error) {
        console.error('Error updating cart UI:', error);
      }
    }

    triggerCartEvents(cartState, source) {
      requestAnimationFrame(() => {
        const updateEvent = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cartState,
            sourceId: this.element.id || 'free-gift-block',
            data: {
              didError: false,
              source: source,
              itemCount: cartState.item_count
            }
          }
        });
        
        document.dispatchEvent(updateEvent);
        
        if (source === 'free-gift') {
          const addEvent = new CustomEvent('cart:add', {
            bubbles: true,
            detail: {
              resource: cartState,
              sourceId: this.element.id || 'free-gift-block',
              data: {
                didError: false,
                source: source,
                itemCount: cartState.item_count
              }
            }
          });
          
          document.dispatchEvent(addEvent);
        }
      });
    }

     async removeOrphanedGifts(cartState) {
       if (!cartState.items || cartState.items.length === 0) return;
       
       const mainProductVariantIds = cartState.items
         .filter(item => !item.properties || !item.properties._free_gift)
         .map(item => item.variant_id.toString());
       
       const orphanedGifts = cartState.items.filter(item => {
         if (!item.properties || !item.properties._free_gift) return false;
         
         const linkedVariantId = item.properties._linked_to_variant;
         if (!linkedVariantId) return false;
         
         return !mainProductVariantIds.includes(linkedVariantId.toString());
       });
       
       if (orphanedGifts.length > 0) {
         console.log('Removing orphaned gifts:', orphanedGifts);
         
         for (const gift of orphanedGifts) {
           await this.removeCartItem(gift.key);
         }
         
         const updatedCartState = await this.fetchCartState();
         await this.updateCartUI(updatedCartState, 'gift-cleanup');
       }
     }

     async removeCartItem(itemKey) {
       try {
         const response = await fetch('/cart/change.js', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json',
           },
           body: JSON.stringify({
             id: itemKey,
             quantity: 0
           })
         });

         if (!response.ok) {
           throw new Error('Failed to remove cart item');
         }

         return response.json();
       } catch (error) {
         console.error('Error removing cart item:', error);
         throw error;
       }
     }

         async updateCartUI(cartState, source = 'gift-cleanup') {
      this.triggerCartEvents(cartState, source);
    }

     async fetchCartState() {
       const response = await fetch('/cart.js');
       if (!response.ok) {
         throw new Error('Failed to fetch cart state');
       }
       return response.json();
     }


    showSuccessMessage() {
      const message = document.createElement('div');
      message.innerHTML = `
        <div style="
          position: fixed;
          top: 20px;
          right: 20px;
          background: var(--color-success, #4ade80);
          color: white;
          padding: 12px 16px;
          border-radius: 8px;
          z-index: 1000;
          font-size: 14px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        ">
          ✓ Produkt und Geschenke hinzugefügt!
        </div>
      `;
      
      document.body.appendChild(message);
      
      setTimeout(() => {
        message.remove();
      }, 3000);
    }

         showGiftRemovalMessage(count) {
       const message = document.createElement('div');
       message.innerHTML = `
         <div style="
           position: fixed;
           top: 20px;
           right: 20px;
           background: var(--color-warning, #f59e0b);
           color: white;
           padding: 12px 16px;
           border-radius: 8px;
           z-index: 1000;
           font-size: 14px;
           box-shadow: 0 4px 12px rgba(0,0,0,0.15);
         ">
           ℹ ${count} Geschenk${count > 1 ? 'e' : ''} entfernt
         </div>
       `;
       
       document.body.appendChild(message);
       
       setTimeout(() => {
         message.remove();
       }, 2000);
     }

     showErrorMessage() {
       const message = document.createElement('div');
       message.innerHTML = `
         <div style="
           position: fixed;
           top: 20px;
           right: 20px;
           background: var(--color-error, #ef4444);
           color: white;
           padding: 12px 16px;
           border-radius: 8px;
           z-index: 1000;
           font-size: 14px;
           box-shadow: 0 4px 12px rgba(0,0,0,0.15);
         ">
           ⚠ Fehler beim Hinzufügen zum Warenkorb
         </div>
       `;
       
       document.body.appendChild(message);
       
       setTimeout(() => {
         message.remove();
       }, 2000);
     }
  }

  function initializeFreeGiftComponents() {
    const elements = document.querySelectorAll('.free-gift-block:not([data-initialized])');
    elements.forEach(element => {
      element.dataset.initialized = 'true';
      new FreeGiftComponent(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFreeGiftComponents);
  } else {
    initializeFreeGiftComponents();
  }

  document.addEventListener('shopify:section:load', initializeFreeGiftComponents);
  document.addEventListener('shopify:block:select', initializeFreeGiftComponents);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quantity-discount"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
      const quantityDiscountElement = document.getElementById('quantity-discount');
      
      if (!quantityDiscountElement) return;
      
      const startDateStr = quantityDiscountElement.dataset.startDate;
      const endDateStr = quantityDiscountElement.dataset.endDate;
      const showCountdown = quantityDiscountElement.dataset.showCountdown === 'true';
      const countdownText = quantityDiscountElement.dataset.countdownText || 'Only';
      
      function parseDateTime(dateTimeStr) {
          if (!dateTimeStr) return null;
          
          try {
              const [datePart, timePart] = dateTimeStr.split(' ');
              const [year, month, day] = datePart.split('-').map(Number);
              const [hour, minute] = timePart.split(':').map(Number);
              
              return new Date(year, month - 1, day, hour, minute, 0);
          } catch (error) {
              console.error('Invalid date format:', dateTimeStr);
              return null;
          }
      }
      
      function formatTimeRemaining(remainingMs) {
          const days = Math.floor(remainingMs / (1000 * 60 * 60 * 24));
          const hours = Math.floor((remainingMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((remainingMs % (1000 * 60)) / 1000);
          
          if (days > 0) {
              return `${days} day${days !== 1 ? 's' : ''}, ${hours}:${minutes.toString().padStart(2, '0')} hours`;
          } else if (hours > 0) {
              return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} hours`;
          } else {
              return `${minutes}:${seconds.toString().padStart(2, '0')} minutes`;
          }
      }
      
      function updateQuantityDiscount() {
          const now = new Date();
          const startTime = parseDateTime(startDateStr);
          const endTime = parseDateTime(endDateStr);
          
          if (!startTime || !endTime) {
              console.error('Invalid start or end date format');
              return;
          }
          
          const isActive = now >= startTime && now < endTime;
          
          if (isActive) {
              quantityDiscountElement.classList.add('active');
              
              if (showCountdown) {
                  const remainingMs = endTime.getTime() - now.getTime();
                  
                  if (remainingMs > 0) {
                      const timeString = formatTimeRemaining(remainingMs);
                      const timeElement = document.getElementById('quantity-discount-time');
                      
                      if (timeElement) {
                          timeElement.textContent = `${countdownText}: ${timeString}`;
                      }
                  }
              }
          } else {
              quantityDiscountElement.classList.remove('active');
          }
      }
      
      updateQuantityDiscount();
      setInterval(updateQuantityDiscount, 1000);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-estimation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const ratingButtons = document.querySelectorAll('.rating-category-btn');
  const progressFillBar = document.getElementById('progressFillBar');
  const progressIndicatorHandle = document.getElementById('progressIndicatorHandle');
  const scaleLabelLeft = document.getElementById('scaleLabelLeft');
  const scaleLabelCenter = document.getElementById('scaleLabelCenter');
  const scaleLabelRight = document.getElementById('scaleLabelRight');
  
  if (ratingButtons.length > 0) {
    const activeButton = document.querySelector('.rating-category-btn.is-active');
    if (!activeButton) {
      ratingButtons[0].classList.add('is-active');
    }

    const initialActiveButton = document.querySelector('.rating-category-btn.is-active');
    if (initialActiveButton) {
      const initialValue = parseInt(initialActiveButton.dataset.ratingValue) || 0;
      updateProgressDisplay(initialValue);
      updateScaleLabels(initialActiveButton);
    }
  }
  
  ratingButtons.forEach(button => {
    button.addEventListener('click', function() {

      ratingButtons.forEach(btn => btn.classList.remove('is-active'));
      
      this.classList.add('is-active');
      
      const ratingValue = parseInt(this.dataset.ratingValue) || 0;
      updateProgressDisplay(ratingValue);
      
      updateScaleLabels(this);
    });
  });
  
  function updateProgressDisplay(value) {
    const safeValue = Math.max(0, Math.min(100, value));
    if (progressFillBar && progressIndicatorHandle) {
      progressFillBar.style.width = safeValue + '%';
      progressIndicatorHandle.style.left = safeValue + '%';
    }
  }
  
  function updateScaleLabels(button) {
    if (scaleLabelLeft && scaleLabelCenter && scaleLabelRight) {
      scaleLabelLeft.textContent = button.dataset.labelLeft || 'SMALL';
      scaleLabelCenter.textContent = button.dataset.labelCenter || 'REGULAR';
      scaleLabelRight.textContent = button.dataset.labelRight || 'WIDE';
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
